import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-basic-info1',
  templateUrl: './basic-info1.component.html',
  styleUrls: ['./basic-info1.component.scss'],
})
export class BasicInfo1Component implements OnInit {
  @Input() data: any;
  constructor() {
    //empty
  }

  ngOnInit(): void {
    console.log();
  }
}
